
var ViewFactory = require('tplify/dist/viewFactory').default;

delete module.exports;

var viewFactory = new ViewFactory('<iframe data-name="frame"\n  width="600"\n  height="450"\n  frameborder="0" style="border:0;width:60vw;height:60vh;min-height:250px;min-width:250px;padding-top:0.5rem" allowfullscreen>\n</iframe>\n');

Object.defineProperty(module, 'exports', {
get: function() {
    return viewFactory.create();
}
});
